let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kSI4e")).then(() => parcelRequire('gfPZB'));